// extracted by mini-css-extract-plugin
export default {"sizesGuide":"SizeGuideLoader-sizesGuide-wVT"};